import {Route} from 'react-router-dom'

import {ThePleoProduct} from './the-pleo-product'

export const routes = (
    <>
        <Route>
            <Route index element={<ThePleoProduct />} />
            {/* Add following course routes here */}
        </Route>
    </>
)
